import $ from 'jquery'
import {getHost} from '../../common/js/util';
import requestConfig from '../../config/config'

export default {
    init: (config, resolve) => {
        $.ajax({
            type: 'get',
            url: getHost() + requestConfig.SITE_NAV.url,
            data: {
                cityId: config.cityId
            },
            success: function (result) {
                resolve(result)
            },
            error: function (err) {
                console.log('site nav 数据请求失败', err)
            }
        });
    }
}



// WEBPACK FOOTER //
// ./modules/top-nav/js/site-category.js